import { useEffect, useState } from "react";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { MASK_MONEY } from "../../../theme/Component/BasicTable2";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { EditorContractArticles } from "../../../contract/etapa-contrato/contrac/EditorContractArticles";
import { SelectorRPBudgetContract } from "../../../contract/etapa-contrato/contrac/adquisitionContractRP/SelectorRPBudgetContract";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { EditorBudgetItemArticles } from "./EditorBudgetItemArticles";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
interface Props {
    SupplierPaymentOrder: any;
    addType?: "fromRP" | "fromArticle";
    onUpdate?: any;
    listLength?: Function;
}

export const SupplierPaymentOrderItem = ({ SupplierPaymentOrder, onUpdate, addType = "fromRP", listLength }: Props) => {

    const { instance, setLista, lista, bean, setBean } = useDataBean(_SupplierPaymentOrderItem);
    const [budgetList, setBudgetList] = useState<any>([])
    const [response, setResponse] = useState<any>({})
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const modalEditar = useModal("Orden", MODAL_md);

    useEffect(() => {
        if (SupplierPaymentOrder.IDSupplierPaymentOrder) {
            getLista();
            getBudgetPayment();
        }
    }, [SupplierPaymentOrder])

    useEffect(() => {
        if (listLength) {
            listLength(lista.length)
        }
    }, [lista])

    const getLista = () => {
        instance.getSupplierPaymentOrderItemCatalogForAdquisitionContract(SupplierPaymentOrder.IDSupplierPaymentOrder, SupplierPaymentOrder.SupplierPaymentOrderDate).then(
            (resp: any) => {
                if (resp) {
                    let List = resp;
                    List.forEach((e: any) => {
                        if (e.DataBeanProperties.BudgetJsconCode) {
                            e.DataBeanProperties.Budget = (e.DataBeanProperties.BudgetJsconCode ?? '') + ' / ' + (e.DataBeanProperties.BudgetName ?? '');
                        }
                    })
                    setLista(List);
                }
            }
        )
    }

    const getBudgetPayment = () => {
        instance.getRecordBudgetBySupplierPaymentOrder2(SupplierPaymentOrder.IDSupplierPaymentOrder, SupplierPaymentOrder.SupplierPaymentOrderDate).then(
            (resp) => {
                const x = resp;

                x.forEach(element => {
                    element.DataBeanProperties.CDPEntity = `${element.DataBeanProperties.CDPMnemonic} - ${element.DataBeanProperties.CDPConsecutive}`
                    element.DataBeanProperties.RPEntity = `${element.DataBeanProperties.Mnemonic} - ${element.DataBeanProperties.Consecutive}`
                });

                setBudgetList(resp)
            }
        ).catch(err => {
            console.log(err)
        })
    }

    const create = () => {
        modalEditar.open();
        setBean({});
    }

    const deleteItem = () => {
        instance.deleteSupplierPaymentOrderItem(bean.IDSupplierPaymentOrderItem, bean.Since, _single.getAccountID()).then(
            (resp) => {
                //console.log(resp);
                getLista();

                setModalC({ ...modalC, "view": false });
            }
        )
    }

    const editaItem = () => {
        //console.log(SupplierPaymentOrderItem.bean);
        instance.addPaymentOrderItem(SupplierPaymentOrder.IDSupplierPaymentOrder, SupplierPaymentOrder.SupplierPaymentOrderDate, bean.IDAdquisitionArticle, bean.IDBudgetType, bean.IDBudgetResource, bean.IDBudgetSource, bean.Value).then(
            (resp: any) => {
                getLista();
                modalEditar.close();
                // modalConfirm.close();
                if (onUpdate) {
                    onUpdate();
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const editaItemFromRP = () => {
        console.log(SupplierPaymentOrder.IDSupplierPaymentOrder + " " + SupplierPaymentOrder.SupplierPaymentOrderDate + " " + response.budgetIDStr + " " + response.idBudgetResource + " " + response.idBudgetSource + " " + response.Value);
        instance.addPaymentOrderItemFromRP(SupplierPaymentOrder.IDSupplierPaymentOrder, SupplierPaymentOrder.SupplierPaymentOrderDate, response.budgetIDStr, response.idBudgetResource, response.idBudgetSource, response.Value).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                if (onUpdate) {
                    onUpdate();
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }



    const getBuget = () => {
        instance.getRecordBudgetBySupplierPaymentOrder(SupplierPaymentOrder.IDSupplierPaymentOrder, SupplierPaymentOrder.SupplierPaymentOrderDate, bean.BudgetJsconCode).then(
            (resp) => {
                console.log(resp)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDSupplierPaymentOrderItem', visible: true, mask: MASK_NUMBER },
        { title: 'Rubro Presupuestal', property: 'BudgetIDStr', visible: true },
        { title: 'Reurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente Presupuestal', property: 'BudgetSourceName', visible: true },
        { title: 'Valor', property: 'PaymentValue', visible: true, mask: MASK_MONEY },
        { title: 'Fecha', property: 'Since', visible: true, mask: MASK_DATE },
        // { title: 'ID Artículo', property: 'IDAdquisitionArticle', visible: false, mask: MASK_NUMBER },
        // { title: 'Descripción', property: 'Description', visible: true },
        // { title: 'Rubro Presupuestal', property: 'BudgetIDStr', visible: true },
        // { title: 'Código CPC', property: 'IDLncPCP', visible: true },
        // { title: 'Tipo Arículo', property: 'TypeName', visible: true },
        // { title: 'Unidad Medida', property: 'MeasurementUnit', visible: true },
        // { title: 'Ubicación', property: 'SiteIDName', visible: true },
        // { title: 'Cantidad', property: 'Quantity', visible: true, mask: MASK_NUMBER },
        // { title: 'Valor', property: 'PaymentValue', visible: true, mask: MASK_MONEY },
    ]

    const createFromRp = () => {
        setModal({ ...modal, "view": true, "name": "Agregar Item desde Registro Presupuestal" });
        setResponse({});
    }

    const iconButtonsItem = [
        { nombre: 'Agregar Artículo para Pago desde Artículos', visible: (_single.canCreate() && addType === "fromArticle"), icono: 'ri-file-add-line', evento: create },
        { nombre: 'Agregar Item de Pago desde Registro Presupuestal', visible: (_single.canCreate() && addType === "fromRP"), icono: 'ri-file-download-line', evento: createFromRp },
    ]

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { modalEditar.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        if (bean.BudgetJsconCode) {
            setBean({ ...bean });
            getBuget();
        }
    }, [bean.IDAdquisitionArticle])

    const setValue = (e: any) => {
        // if (e === "") {
        //     setResponse({ ...response, "IDDocument": "", "budgetIDStr": null, "idBudgetResource": null, "idBudgetSource": null })
        // } else {
        //     const selectedItem = budgetList.find(item => item.DataBeanProperties.IDDocument == e);
        // setResponse({ ...response, "IDDocument": selectedItem?.DataBeanProperties.IDDocument, "budgetIDStr": selectedItem?.DataBeanProperties.BudgetIDStr, "idBudgetResource": selectedItem?.DataBeanProperties.IDBudgetResource, "idBudgetSource": selectedItem?.DataBeanProperties.IDBudgetSource, "Value": selectedItem?.DataBeanProperties.Value });
        // }
        console.log(e);
        setResponse({ ...response, "IDDocument": e.IDDocument, "budgetIDStr": e.BudgetIDStr, "idBudgetResource": e.IDBudgetResource, "idBudgetSource": e.IDBudgetSource, "Value": e.Value });
    };

    const headBudget = [
        { title: 'Rubro Presupuestal', property: 'BudgetIDStr', visible: true },
        { title: 'CDP Asociado', property: 'CDPEntity', visible: true },
        { title: 'RP Asociado', property: 'RPEntity', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Fecha', property: 'Since', visible: true, mask: MASK_DATE },

    ]


    return (

        <div className="row">
            <div className="col-md-12">
                <p>{SupplierPaymentOrder.Description}</p>
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
            </div>

            <div className="col-md-12">
                <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <EditorContractArticles idAdquisitionContract={SupplierPaymentOrder.IDAdquisitionContract} onChange={(e) => {
                                setBean({ ...bean, "IDAdquisitionArticle": e.IDAdquisitionArticle, "Value": e.ContractedValue, "BudgetJsconCode": e.BudgetJsconCode });
                            }} />
                        </div>
                        <div className="col-md-12">
                            <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }); }} _label="Valor" />
                        </div>
                        <div className="col-md-12">
                            <EditorBudgetItemArticles onChange={(e) => { setBean({ ...bean, "IDBudgetType": e.IDBudgetType, "IDBudgetResource": e.IDBudgetResource, "IDBudgetSource": e.IDBudgetSource }) }} ItemJsconCode={bean.BudgetJsconCode} SupplierPaymentOrder={SupplierPaymentOrder} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={editaItemFromRP}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Registro Presupuestal</label>
                            <BasicTable body={budgetList} head={headBudget} rowSet={setValue} />
                            {/* <select className="form-select" value={response.IDDocument} onChange={(e) => { setValue(e.target.value) }}>
                                <option value={""}>...</option>
                                {budgetList &&
                                    budgetList.map((item: any, index: number) => {
                                        return (
                                            <option key={index} value={item.DataBeanProperties.IDDocument} >{item.DataBeanProperties.Mnemonic} - {item.DataBeanProperties.Consecutive} - ${item.DataBeanProperties.Value}</option>
                                        )
                                    })
                                }
                            </select> */}
                        </div>
                        <div className="col-md-12">
                            <InputMoney _value={response.Value} onChange={(e) => { setResponse({ ...response, "Value": e }); }} _label="Valor a Pagar" />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}